import {OrderType} from './types';
import Localized from 'src/constants/AppStrings';

export const STEP_LABELS: Record<OrderType, [string, string, string]> = {
  OrderNow: [
    (Localized as any)?.Labels?.order_now_step_1 || 'Sent',
    (Localized as any)?.Labels?.order_now_step_2 || 'Preparing',
    (Localized as any)?.Labels?.order_now_step_3 || 'Ready',
  ],
  OrderAhead: [
    (Localized as any)?.Labels?.order_ahead_step_1 || 'Scheduled',
    (Localized as any)?.Labels?.order_ahead_step_2 || 'Preparing',
    (Localized as any)?.Labels?.order_ahead_step_3 || 'Ready',
  ],
};

export const stepToPercent = (step: number, total = 3) =>
  Math.min(Math.max((step - 1) / (total - 1), 0), 1);
